import React, { useState } from "react";
import { Sidebar } from "../Sidebar/Sidebar";
import "./LayoutShell.css";

export const LayoutShell = ({
  isPWADialer,
  outBoundLeadsDetail,
  setOutBoundLeadsDetail,
  setUserDataAccess,
  setCurrentRoute,
  setIsUploadLead,
  setIsTabClick,
  isTabClick,
  children,
}) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="container-fluid app-shell">
      <div className="row flex-nowrap app-shell__row">
        <div
          id="sideBar"
          className={`app-shell__sidebar ${
            sidebarCollapsed ? "app-shell__sidebar--collapsed" : "app-shell__sidebar--expanded"
          } ${isPWADialer ? "d-none" : ""}`}
        >
          <Sidebar
            collapsed={sidebarCollapsed}
            onToggleCollapse={() => setSidebarCollapsed((currentValue) => !currentValue)}
            outBoundLeadsDetail={outBoundLeadsDetail}
            setOutBoundLeadsDetail={setOutBoundLeadsDetail}
            setUserDataAccess={setUserDataAccess}
            setCurrentRoute={setCurrentRoute}
            setIsUploadLead={setIsUploadLead}
            setIsTabClick={setIsTabClick}
            isTabClick={isTabClick}
          />
        </div>
        <div className="layout app-shell__content">{children}</div>
      </div>
    </div>
  );
};
